import { HttpLoaderFactory } from '../../../application/translation/httpLoaderFactory';
const ɵ0 = HttpLoaderFactory;
export class ViewsModule {
}
export { ɵ0 };
